export const SERVICE_SORTS = {
	// Note(Curstantine): Fundamentally both createdAt:desc and default are the same thing.
	default: "Default",
	"createdAt:desc": "Latest",
	"createdAt:asc": "Oldest",
	"isPopular:desc": "Popular",
	"price:desc": "Highest Price",
	"price:asc": "Lowest Price",
} as const;

export const BLOG_SORTS = {
	// Note(Curstantine): Fundamentally both createdAt:desc and default are the same thing.
	default: "Default",
	"createdAt:desc": "Latest",
	"createdAt:asc": "Oldest",
	"isPopular:desc": "Popular",
} as const;

export const ADMIN_ORDER_SORTS = {
	// Note(Curstantine): Fundamentally both createdAt:desc and default are the same thing.
	default: "Default",
	"createdAt:desc": "Latest",
	"createdAt:asc": "Oldest",
	"title:asc": "Title",
};
